import { createReducer, on } from '@ngrx/store';
import { OcrActions } from './ocr.actions';
import { OcrState, ocrState } from './ocr.state';

export const ocrReducer = createReducer(
  ocrState,
  on(
    OcrActions.reset,
    (): OcrState => ({
      ehr: null,
      data: [],
      file: undefined,
      uploading: false,
      onboarding: false,
      uploadFile: false
    })
  ),
  on(OcrActions.addData, (state, { item }): OcrState => {
    if (state.data.some((v) => v.name === item.name)) return state;
    return { ...state, data: [...state.data, item] };
  }),
  on(OcrActions.setEHR, (state, { ehr }): OcrState => ({ ...state, ehr })),
  on(OcrActions.setData, (state, { data }): OcrState => ({ ...state, data })),
  on(OcrActions.setFile, (state, { file }): OcrState => ({ ...state, file })),
  on(
    OcrActions.setUploading,
    (state, { uploading }): OcrState => ({
      ...state,
      uploading,
      data: uploading ? [] : [...state.data]
    })
  ),
  on(
    OcrActions.setUploadFile,
    (state, { uploadFile }): OcrState => ({ ...state, uploadFile })
  ),
  on(
    OcrActions.setOnboarding,
    (state, { onboarding }): OcrState => ({ ...state, onboarding })
  )
);
